import {
  SET_RECIPES,
  DELETE_RECIPE,
  UPDATE_RECIPE,
} from "../../constants/reducerEvents";
import { deleteRecipe, updateRecipe } from "../../endpoints/endpoints";

const INITIAL_STATE = [];
export default function recipeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_RECIPES:
      return action.payload;
    case DELETE_RECIPE:
      deleteRecipe(action.payload);
      return state.filter((r) => r.id !== action.payload.id);
    case UPDATE_RECIPE:
      updateRecipe(action.payload);
      return state.map((r) =>
        r.id === action.payload.id ? action.payload : r
      );
    default:
      return state;
  }
}
